import React, { useState } from "react"

import Header from "../../components/Header"
import SubRoutes from "./SubRoutes"

import "primereact/resources/themes/saga-green/theme.css"
import "primereact/resources/primereact.min.css"
import "primeicons/primeicons.css"

import "./style.css"

//Toast
import "react-toastify/dist/ReactToastify.css"

import { useNotification } from "hooks/notification"
import { useAuth } from "hooks/auth"
import PausedModal from "components/PausedModal"

export default function Dashboard({ history, isPrivate, ...rest }) {
  const [hide, setHide] = useState(false)
  const { hideTopBar } = useNotification()
  const { setIsPaused, user } = useAuth()

  const handleSideBar = () => {
    setHide(!hide)
  }

  React.useEffect(() => {
    const isPaused = sessionStorage.getItem("@Omni:isPaused")
    if (Boolean(isPaused) || user.isPaused) {
      setIsPaused(true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className="container-home">
      <div style={{ overflow: "scroll" }}>
        <Header history={history} HideSideBar={handleSideBar} />
      </div>
      <div
        style={{
          marginTop: hideTopBar ? 70 : 120,
          // height: `calc(100vh - ${hideTopBar ? 70 : 120}px)`,
          overflowY: "scroll", // Add vertical scrolling
        }}
        className="container-wrapper"
      >
        <div className="container-home-area-central">
          <div className="container-user-page" style={{ marginTop: 10 }}>
            <div
              className="content-page"
              style={{
                paddingBottom: 0,
                minHeight: "77vh",
                marginBottom: 20,
                paddingRight: 0,
              }}
            >
              <PausedModal />
              <SubRoutes />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
